export const REQUIRED_MESSAGE = "Required";

export const MAX_CHARACTER_MESSAGE = "Cannot enter more than 255 characters";
export const MAX_1_CHARACTERS_MESSAGE = "Cannot enter more than 1 characters";
export const MAX_3_CHARACTERS_MESSAGE = "Cannot enter more than 3 characters";
export const MAX_5_CHARACTERS_MESSAGE = "Cannot enter more than 5 characters";

export const EMAIL_VALIDATION_MESSAGE =
  "Incomplete email format. Make sure your email contains '@' and the full domain.";

export const YEAR_VALIDATION_MESSAGE =
  " Please enter the year in the correct format (4-digit number).";

export const MISSING_ID_IN_ROUTE =
  "Missing id param in react router dynamic segment";

export const FIRST = 0;

export const ROLE = {
  ADMINISTRATOR: "administrator",
  MONITORING_TEAM: "monitoring_team",
  REVISE_DOCUMENT_OFFICER: "revise_document_officer",
  VALIDATOR_DOCUMENT_OFFICER: "validator_document_officer",
  VENDOR: "vendor",
  FUNNEL_MANAGEMENT: "funnel_management",
  FUNNEL_PROJECT: "funnel_project",
  PROJECT_OPERATIONAL_LEAD: "permit_project_operation_lead",
  PROJECT_MANAGER: "permit_project_manager",
  PERMIT_DISPATCH: "permit_dispatch",
  PERMIT_MONITORING: "permit_monitoring",
  LM_FEEDER_DESIGN: "apd_lm_feeder_design",
  BB_DESIGN: "apd_bb_design",
  COSTING: "apd_costing",
  BB_COSTING: "apd_bb_costing",
  PBO: "apd_pbo",
  AGG_HLD: "agg_hld",
  SYS_ADMIN: "sys_admin",
  AGG_FUNNEL_PROJECT: "agg_funnel_project",
  AGG_PROJECT_MANAGER: "agg_project_manager",
  AGG_OPERATIONAL_LEAD: "agg_project_operation_lead",
  AGG_PERMIT_MONITORING: "agg_permit_monitoring",
  AGG_PERMIT_DISPATCH: "agg_permit_dispatch",
  FEEDER_FUNNEL_PROJECT: "feeder_funnel_project",
  FEEDER_PERMIT_DISPATCH: "feeder_permit_dispatch",
  FEEDER_PERMIT_MONITORING: "feeder_permit_monitoring",
  FEEDER_HEAD_OF_PERMIT: "feeder_head_permit",
  FEEDER_HEAD_OF_PROJECT: "feeder_head_project",
  FOOLT_FUNNEL_PROJECT: "foolt_funnel_project",
  FOOLT_PERMIT_DISPATCH: "foolt_permit_dispatch",
  FOOLT_PERMIT_MONITORING: "foolt_permit_monitoring",
  FOOLT_HEAD_OF_PERMIT: "foolt_head_permit",
  FOOLT_HEAD_OF_PROJECT: "foolt_head_project",
  RING_FUNNEL_PROJECT: "ring_funnel_project",
  RING_PERMIT_DISPATCH: "ring_permit_dispatch",
  RING_PERMIT_MONITORING: "ring_permit_monitoring",
  RING_HEAD_OF_PERMIT: "ring_head_permit",
  RING_HEAD_OF_PROJECT: "ring_head_project",
  VENDOR_VIEW: "vendor_view",
  // ABD BB
  ABD_RING_REGIONAL_CONSTRUCTION: "abd_ring_regional_construction",
  ABD_RING_APPROVER: "abd_ring_approver",
  ABD_RING_VERIFICATOR: "abd_ring_verificator",
  ABD_RING_PBO: "abd_ring_pbo",
  ABD_RING_MAINTENANCE: "abd_ring_maintenance",
  ABD_RING_VIEW: "abd_ring_view",
  ABD_RING_HQ_CONSTRUCTION: "abd_ring_hq_construction",
  // ABD FEEDER
  ABD_FEEDER_VERIFICATOR_LM: "abd_feeder_verificator_lm",
  ABD_FEEDER_VERIFICATOR: "abd_feeder_verificator",
  ABD_FEEDER_APPROVER: "abd_feeder_approver",
  ABD_FEEDER_PBO: "abd_feeder_pbo",
  ABD_FEEDER_MAINTENANCE: "abd_feeder_maintenance",
  ABD_FEEDER_VIEW: "abd_feeder_view",
  // ABD FO OLT
  ABD_FOOLT_REGIONAL_CONSTRUCTION: "abd_foolt_regional_construction",
  ABD_FOOLT_APPROVER: "abd_foolt_approver",
  ABD_FOOLT_VERIFICATOR: "abd_foolt_verificator",
  ABD_FOOLT_PBO: "abd_foolt_pbo",
  ABD_FOOLT_MAINTENANCE: "abd_foolt_maintenance",
  ABD_FOOLT_VIEW: "abd_foolt_view",
  ABD_FOOLT_HQ_CONSTRUCTION: "abd_foolt_hq_construction",
  // View Only
  FUNNEL_VIEW: "funnel_view",
  HLD_VIEW: "hld_view",
  PERMIT_AGG_VIEW: "permit_agg_view",
  APD_BB_VIEW: "apd_bb_view",
  PERMIT_FEEDER_VIEW: "permit_feeder_view",
  SYS_ADMIN_VIEW: "sys_admin_view",
  PERMIT_RING_VIEW: "permit_ring_view",
  PERMIT_FOOLT_VIEW: "permit_foolt_view",
  APD_VIEW: "apd_view",
  PERMIT_VIEW: "permit_view",

  // WO Management
  NOSA: "wo_nosa",
  ENTERPRISE: "wo_enterprise",
  WO_VIEW: "wo_view",
} as const;

export const ROLE_NAMES = {
  administrator: "Administrator",
  agg_funnel_project: "Permit Rent - Funnel Project",
  agg_hld: "Permit Rent - HLD",
  agg_permit_dispatch: "Permit Rent - Permit Dispatch",
  agg_permit_monitoring: "Permit Rent - Permit Monitoring",
  agg_project_manager: "Permit Rent - Project Manager",
  agg_project_operation_lead: "Permit Rent - Project Operation Lead",
  apd_bb_costing: "APD - BB Costing",
  apd_bb_design: "APD - BB Design",
  apd_bb_view: "View Only - APD BB",
  apd_costing: "APD - Costing",
  apd_lm_feeder_design: "APD - LM Feeder Design",
  apd_pbo: "APD - PBO",
  apd_view: "View Only - APD",
  feeder_funnel_project: "Permit Feeder - Funnel Project",
  feeder_head_permit: "Permit Feeder - Head of Permit",
  feeder_head_project: "Permit Feeder - Head of Project",
  feeder_permit_dispatch: "Permit Feeder - Permit Dispatch",
  feeder_permit_monitoring: "Permit Feeder - Permit Monitoring",
  foolt_funnel_project: "Permit FO OLT - Funnel Project",
  foolt_head_permit: "Permit FO OLT - Head of Permit",
  foolt_head_project: "Permit FO OLT - Head of Project",
  foolt_permit_dispatch: "Permit FO OLT - Permit Dispatch",
  foolt_permit_monitoring: "Permit FO OLT - Permit Monitoring",
  funnel_management: "Funnel Management",
  funnel_project: "Funnel Project",
  funnel_view: "View Only - Funnel",
  hld_view: "View Only - HLD",
  monitoring_team: "Monitoring Team",
  permit_agg_view: "View Only - Permit Rent",
  permit_dispatch: "Permit Dispatch",
  permit_feeder_view: "View Only - Permit Feeder",
  permit_foolt_view: "View Only - Permit FO OLT",
  permit_monitoring: "Permit Monitoring",
  permit_project_manager: "Project Manager",
  permit_project_operation_lead: "Project Operation Lead",
  permit_ring_view: "View Only - Permit Ring BB",
  permit_view: "View Only - Permit",
  ring_funnel_project: "Permit Ring BB - Funnel Project",
  ring_head_permit: "Permit Ring BB - Head of Permit",
  ring_head_project: "Permit Ring BB - Head of Project",
  ring_permit_dispatch: "Permit Ring BB - Permit Dispatch",
  ring_permit_monitoring: "Permit Ring BB - Permit Monitoring",
  sys_admin_view: "View Only - Administrator",
  validator_document_officer: "Validator Document Officer",
  vendor: "Vendor",
  vendor_view: "View Only - Vendor",
  wo_nosa: "NOSA",
  wo_enterprise: "Enterprise",
  wo_view: "View Only - WO Management",
} as const;

export const STATUS = {
  RFS: {
    PREPARATION_DATA: "Prepare & Validate",
    REVISION_DATA: "Draft (Invalid)",
    REVISION_BY_LN: "In Review",
    REJECTED_DOCUMENT_RFS: "Rejected",
    CANCELED: "Cancelled",
    GENERATING_HPDB: "Generate HPDB",
    WAITING: "Waiting RFS Submission",
    TENANT_REVIEW: "On Review by Tenant",
    TENANT_REJECT: "Rejected by Tenant",
    TENANT_APPROVE: "Approved by Tenant",
    TOTAL_BUCKET_TENANT: "Total Bucket Tenant",
    TOTAL_BUCKET_LINKNET: "Total Bucket Linknet",
    TOTAL_BUCKET_VENDOR: "Total Bucket Vendor",
  },
  RFS_SUBMISSIONS: {
    REVIEW_BY_LN: "REVIEW_BY_LN",
    GENERATING_HPDB: "GENERATING_HPDB",
    REVISION_DATA: "REVISION_DATA",
    PREPARATION_DATA: "PREPARATION_DATA",
    REJECTED_DOCUMENT_RFS: "REJECTED_DOCUMENT_RFS",
  },
  RFS_SUBMISSIONS_VALUES: {
    TENANT_REVIEW: "On Review by Tenant",
    TENANT_APPROVE: "Approved by Tenant",
    SUBMIT_TO_TENANT: "Submit to Tenant",
    PREPARE_SUBMIT_TO_TENANT: "Prepare Submit to Tenant",
    REJECTED_BY_TENANT_TO_LINKNET: "Rejected by Tenant to Linknet",
    REJECTED_BY_TENANT_TO_VENDOR: "Rejected by Tenant to Vendor",
    PROCESSING_HPM: "Processing HPM",
  },
  VALIDATION: {
    IN_PROGRESS: "IN_PROGRESS",
    SUCCESS: "SUCCESS",
    FAILED: "FAILED",
  },
  DOCUMENT: {
    VALIDATED: "Validated",
    UNVALIDATED: "Unvalidated",
    VALIDATING: "Validating",
    FAILED: "Failed",
  },
  LMS_SUBMISSION: {
    PARAM_TYPE: {
      STATUS_INTEGRATION_XL: "STATUS_INTEGRATION_XL",
    },
    VALUE: {
      APPROVED_BY_TENANT: "Approved by Tenant",
      REJECTED_BY_TENANT: "Rejected by Tenant",
    },
  },
};
